<template>
    <div style="position: relative;" >
        <div>


            <h2 class="oswald-400 section-title-lg text-teal uppercase text-center">Choose Your Plan</h2>
            <div class="flex flex-col md:flex-row items-center md:items-normal justify-center">
                <div class="sub-card flex flex-col items-center border-2 border-gray border-solid text-center" :class="{ 'border-bisnow': publication.id == formData.premium_publication_id }" v-for="publication in publications" :key="publication.id">
                    <h3 class="oswald-400 text-center uppercase">{{ publication.billing_period }}</h3>
                    <h4 class="montserrat-700 text-center">${{ publication.price }}</h4>

                    <button disabled
                            class="subscription-cta bg-gray text-black uppercase montserrat-800" v-if="publication.id == formData.premium_publication_id">Selected</button>
                    <button @click="changePlan(publication)"
                            class="subscription-cta bg-bisnow text-white uppercase montserrat-800" v-else>Select Plan</button>
                </div>
            </div>
        </div>
        <div id="purchase-form" class="row">
            <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12">
                <h2>Subscription Information</h2>
                <div class="orangeBorderWrapperTop">
                    <form class="form-horizontal">

                        <div class="row">
                            <div class="col-sm-6 col-xs-12">
                                <h3 style="margin-top: 0;">Your Information</h3>
                            </div>
                            <div class="col-sm-6 col-xs-12 requiredNotice">
                                <p class="required">* Required Fields</p>
                            </div>
                        </div>

                        <div class="row form-group">
                            <label for="firstName"
                                   class="col-sm-2 col-xs-12 control-label"
                                   :class="{ 'is-invalid': $v.formData.firstName.$error }">First Name: <span
                                class="required">*</span></label>
                            <div class="col-md-3 col-sm-4 col-xs-12">
                                <input type="text" class="form-control" id="firstName" autocomplete="given-name"
                                       v-model="$v.formData.firstName.$model"
                                       @keypress="onlyText($event)"
                                       :class="{ 'is-invalid': $v.formData.firstName.$error }">
                            </div>
                            <label for="lastName"
                                   class="col-sm-2 col-xs-12 control-label"
                                   :class="{ 'is-invalid': $v.formData.lastName.$error }">Last Name: <span
                                class="required">*</span></label>
                            <div class="col-md-3 col-sm-4 col-xs-12">
                                <input type="text" class="form-control" id="lastName" autocomplete="family-name"
                                       v-model="$v.formData.lastName.$model"
                                       @keypress="onlyText($event)"
                                       :class="{ 'is-invalid': $v.formData.lastName.$error }">
                            </div>
                        </div>
                        <div class="row form-group">
                            <label for="email"
                                   class="col-sm-2 col-xs-12 control-label"
                                   :class="{ 'is-invalid': $v.formData.email.$error }">Email: <span
                                class="required">*</span></label>
                            <div class="col-md-3 col-sm-4 col-xs-12">
                                <input type="text" class="form-control" id="email" autocomplete="email"
                                       v-model="$v.formData.email.$model"
                                       @change="$v.formData.email.$model = $event.target.value.toLowerCase()"
                                       :class="{ 'is-invalid': $v.formData.email.$error }">
                            </div>
                            <label for="confirmEmail"
                                   class="col-sm-2 col-xs-12 control-label"
                                   :class="{ 'is-invalid': $v.formData.confirmEmail.$error }">Confirm Email: <span
                                class="required">*</span></label>
                            <div class="col-md-3 col-sm-4 col-xs-12">
                                <input type="text" class="form-control" id="confirmEmail" autocomplete="email"
                                       v-model="$v.formData.confirmEmail.$model"
                                       @change="$v.formData.confirmEmail.$model = $event.target.value.toLowerCase()"
                                       :class="{ 'is-invalid': $v.formData.confirmEmail.$error }">
                            </div>
                        </div>
                        <div class="row form-group">
                            <label for="phone"
                                   class="col-sm-2 col-xs-12 control-label"
                                   :class="{ 'is-invalid': $v.formData.phone.$error }">Cell Phone: <span
                                class="required">*</span></label>
                            <div class="col-md-4 col-sm-5 col-xs-12">
                                <input type="input" class="form-control" id="phone" autocomplete="tel"
                                       maxlength="14"
                                       @keypress="onlyNumbers($event)"
                                       v-model="$v.formData.phone.$model"
                                       :class="{ 'is-invalid': $v.formData.phone.$error }">
                            </div>
                        </div>

                        <!-- Errors rendered in the element -->
                        <errors :errors="errors"/>

                        <processor-hosted-fields-form
                            :verify-card="false"
                            total="0"
                            currency="usd"
                            :user="this.user"
                            :client-token="this.braintreeClientToken"
                            newCardHeading=""
                            @loading="braintreeReady => loading = braintreeReady"
                            @canceled="$emit('canceled')"
                            @paymentTypeChanged="type => paymentType = type"
                            :us-states="usStates"
                            :ach-enabled="false"
                            :active-token="activeToken"
                            :force-save="true"
                            description="Choose a payment method or insert a new one."
                            ref="paymentProcessor"/>

                        <div class="form-group hidden-sm hidden-xs">
                            <div class="col-sm-offset-2 col-md-10 col-sm-10 col-xs-offset-0 col-xs-12">
                                <p>
                                    By clicking "{{ actionLabel }}", I am accepting the <a href="/legal/terms" target="_blank">terms of
                                    service</a> and have read the <a href="/legal/privacy" target="_blank">privacy policy</a>.
                                </p>
                            </div>
                            <div class="col-sm-offset-2 col-md-6 col-sm-10 col-xs-offset-0 col-xs-12">
                                <button class="subscription-cta bg-teal text-white uppercase montserrat-800" @click.prevent="initializeCheckout">
                                    {{ actionLabel }}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div class="hidden-lg col-md-12 col-sm-12 col-xs-12">
                <p>
                    By clicking "{{ actionLabel }}", I am accepting the <a href="/legal/terms" target="_blank">terms of
                    service</a> and have read the <a href="/legal/privacy" target="_blank">privacy policy</a>.
                </p>
                <button class="subscription-cta bg-teal text-white uppercase montserrat-800" @click.prevent="initializeCheckout">Complete
                    {{ actionLabel }}
                </button>
            </div>
        </div>
        <loading
            :active.sync="loading"
            :is-full-page="false"
            :loader="'spinner'">
        </loading>
    </div>
</template>

<script>
import api from '../../api';
import startCase from 'lodash/startCase';
import {required, minLength, numeric, email, sameAs} from 'vuelidate/lib/validators';
import Input from './../../mixins/Input';
import CheckoutMixin from '../../mixins/Checkout';
import validateName from './../../helpers/validateName'
import axios from "axios";


export default {
    props: [
        'braintreeCse',
        'braintreeClientToken',
        'usStates',
        'activeToken',
        'action',
        'actionLabel',
        'method',
        'publications',
        'subscription',
    ],
    mixins: [
        CheckoutMixin,
        Input,
    ],
    data() {
        return {
            formData: {
                firstName: this.user ? this.user.first_name : '',
                lastName: this.user ? this.user.last_name : '',
                email: this.user ? this.user.email.toLowerCase() : '',
                confirmEmail: this.user ? this.user.email.toLowerCase() : '',
                phone: this.user ? this.user.phone : '',
                password: '',
                taxId: '',
                premium_publication_id: this.subscription.premium_publication_id,
            },
            paymentType: 'card',
        }
    },
    validations: {
        formData: {
            firstName: {required, validateName},
            lastName: {required, validateName},
            email: {required, email},
            confirmEmail: {required, sameAsEmail: sameAs('email')},
            password: {},
            phone: {required, numeric, minLength: minLength(10)},
            premium_publication_id: {required},
        }
    },
    computed: {
        validEmail() {

            if (this.$v.formData.email.$invalid) {
                return;
            }

            const validEmail = this.$v.formData.email.$model;

            return () => {
                this.saveEmailToSession(validEmail)
            }

        },
    },
    methods: {
        async checkout() {
            const response = await axios.request({
                method: this.method,
                url: this.action,
                data: this.formData,
            });
            if (response.data.updateResult && response.data.updateResult === false) {
                this.$noty.error('Payment method could not be updated for subscription.')
            }
            if (response.data.retryResult && response.data.retryResult === false) {
                this.$noty.error('Subscription renewal failed with new payment method.')
            }
            return response;
        },
        errorMessages() {
            let errors = [];

            let inputs = Object.keys(this.$v.formData.$model);

            inputs.forEach(input => {
                if (
                    this.$v.formData[input] &&
                    this.$v.formData[input].required !== undefined &&
                    !this.$v.formData[input].required
                ) {
                    errors.push(`${startCase(input)} is required.`)
                }
            });

            if (!this.$v.formData.email.email) {
                errors.push('Please input a valid email.')
            }

            if (!this.$v.formData.confirmEmail.sameAsEmail) {
                errors.push('Confirm Email input must match your Email input.')
            }

            if (!this.$v.formData.phone.minLength) {
                errors.push('Phone input must be at least 10 characters.')
            }

            if (!this.$v.formData.phone.numeric) {
                errors.push('Phone input must have only numeric characters.')
            }

            if (!this.$v.formData.firstName.validateName) {
                errors.push('First Name has invalid characters.')
            }

            if (!this.$v.formData.lastName.validateName) {
                errors.push('Last Name has invalid characters.')
            }

            this.errors = [...this.errors, ...errors];

        },
        getBillingValues() {
            return this.$refs.paymentProcessor.getBillingValues();
        },
        processServerError(key) {
            return this.$refs.paymentProcessor.processServerError(key);
        },
        onBeforeProcessCheckout() {
            this.formData.billing_vat_id = this.formData.taxId;
            this.formData.cc_firstname = this.formData.firstName;
            this.formData.cc_lastname = this.formData.lastName;
            this.formData.first_name = this.formData.firstName;
            this.formData.last_name = this.formData.lastName;
        },
        processClientError(key) {
            return this.$refs.paymentProcessor.processClientError(key);
        },
        validateBilling() {
            return this.$refs.paymentProcessor.validateBilling();
        },
        changePlan(publication) {
            console.log(publication);
            this.formData.premium_publication_id = publication.id
        },
    },
}
</script>

<style lang="scss" scoped>
#purchase-form {
    margin-bottom: 40px;
    font-family: 'Avenir LT Std', Arial, Helvetica, sans-serif;
    font-size: 13px;

    h2, h3, h4 {
        font-family: 'Avenir LT Std', Arial, Helvetica, sans-serif;
        text-transform: uppercase;
    }

    h2 {
        font-weight: lighter;
        font-size: 30px;

        @media (max-width: 500px) {
            font-size: 24px;
        }
    }

    h3 {
        font-size: 22px;
        margin-top: 40px;
        margin-bottom: 0;

        @media (max-width: 500px) {
            font-size: 18px;
            margin-top: 35px;
        }
    }

    h4 {
        font-size: 14px;
        font-weight: bold;
    }

    p {
        font-family: 'Avenir LT Std', Arial, Helvetica, sans-serif;
        font-size: 14px;
        font-weight: lighter;
    }

    a {
        padding: 5px 0 0;
        text-decoration: underline;

        &:hover {
            cursor: pointer;
        }
    }

    .orangeBorderWrapperTop {
        @media (max-width: 992px) {
            padding: 0;
        }
    }

    .requiredNotice {
        text-align: right;

        @media (max-width: 768px) {
            text-align: left;
        }
    }

    .checkoutBtn {
        margin-top: 10px;
        border-radius: 3px;
        font-weight: bold;
    }

    @media (min-width: 769px) {
        .hidden-lg {
            display: block !important;
        }
    }
    @media (min-width: 992px) {
        .hidden-lg {
            display: none !important;
        }
    }

    label {
        padding-top: 15px;
        font-size: 13px;

        @media (max-width: 992px) {
            padding-top: 10px;
        }
        @media (max-width: 768px) {
            margin-bottom: 0;
            padding-bottom: 0;
        }
        @media (max-width: 500px) {
            margin-bottom: 0;
            padding-bottom: 0;
        }

        &.is-invalid {
            color: #e86a6b;
        }

        .required {
            position: absolute;
            top: 10px;
            right: 0;

            @media (max-width: 768px) {
                position: inherit;
                top: inherit;
            }
        }
    }

    input, select {
        background-color: #fbfbfb;
        border: 1px solid #dddddd;
        height: 40px;
        border-radius: 5px;
        box-shadow: none;

        &.is-invalid {
            border: 1px solid #e86a6b;
        }
    }

    select {
        background-image: url('https://s3.amazonaws.com/cdn.bisnow.net/assets/website/selectArrowBlack.png');
        background-size: 8px;
    }

    .required {
        color: #e86a6b;
        font-size: 14px;
    }

    .form-group {
        margin-bottom: 0;
    }

    #formErrors {
        margin: 0;
        padding-top: 0;

        h3 {
            margin: 5px 0;
            font-size: 15px;
            font-weight: bold;
        }

        div.alert-danger {
            border: 1px solid #e86a6b;
            background: #FFF8F9;
            text-align: left;
            color: #333;
        }

        ul {
            padding-left: 35px;

            li {
                font-size: 14px;
            }
        }
    }
}

.topInfo div {
    font-size: 14px;
}

@media (max-width: 768px) {
    .checkoutBtn {
        display: block;
        width: 100%;
    }
}
</style>
